// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wifZ4","newExpiryDate":"styles_newExpiryDate__3v20l","footer":"styles_footer__28JwD"};